<h2 mat-dialog-title>Add to Donations</h2>
<mat-dialog-content>
  <mat-progress-bar *ngIf="isLoading || isSaving" mode="indeterminate"></mat-progress-bar>

  <div class="payment-summary">
    <div><span>Payment Id</span><strong>{{ payment.id }}</strong></div>
    <div><span>Order Id</span><strong>{{ payment.order_id || '-' }}</strong></div>
    <div><span>Amount</span><strong>₹{{ amount }}</strong></div>
    <div><span>Method</span><strong>{{ payment.method }}</strong></div>
    <div><span>Paid on</span><strong>{{ paymentDate | date:'dd-MMM-yyyy hh:mm a' }}</strong></div>
    <div><span>Receipt No.</span><strong>{{ nextReceiptId || '-' }}</strong></div>
  </div>

  <p class="hint warn" *ngIf="isTestRun">
    TEST MODE — saves to {{ env.donations }} with the test receipt counter. Email is set to {{ testEmail }}.
  </p>

  <ng-container *ngIf="!isLoading">
    <p class="hint warn" *ngIf="!candidates.length">
      No attempted donation found for this payment. Enter the donor details manually.
    </p>
    <p class="hint warn" *ngIf="selectedCandidate && +selectedCandidate.amount !== amount">
      The donor form says ₹{{ selectedCandidate.amount }} but ₹{{ amount }} was paid. Please verify before adding.
    </p>
    <mat-form-field appearance="outline" class="w-100" *ngIf="candidates.length > 1">
      <mat-label>Attempted donation ({{ candidates.length }} found)</mat-label>
      <mat-select [value]="selectedCandidate" (selectionChange)="applyCandidate($event.value)">
        <mat-option *ngFor="let c of candidates" [value]="c">{{ candidateLabel(c) }}</mat-option>
      </mat-select>
    </mat-form-field>

    <form [formGroup]="myForm" class="row">
      <mat-form-field appearance="outline" class="col-md-6">
        <mat-label>Full Name</mat-label>
        <input matInput formControlName="donated_by">
        <mat-error>Full Name is <strong>required</strong></mat-error>
      </mat-form-field>
      <mat-form-field appearance="outline" class="col-md-6">
        <mat-label>Mobile</mat-label>
        <input matInput formControlName="mobile" maxlength="10">
        <mat-error>Enter a valid 10 digit mobile</mat-error>
      </mat-form-field>
      <mat-form-field appearance="outline" class="col-md-6">
        <mat-label>Email</mat-label>
        <input matInput formControlName="email">
        <mat-error>Enter a valid email</mat-error>
      </mat-form-field>
      <mat-form-field appearance="outline" class="col-md-6">
        <mat-label>PAN</mat-label>
        <input matInput formControlName="pan" maxlength="10" style="text-transform: uppercase"
               (input)="myForm.controls.pan.setValue($any($event.target).value.toUpperCase())">
        <mat-error>Enter a valid PAN</mat-error>
      </mat-form-field>
      <mat-form-field appearance="outline" class="col-md-12">
        <mat-label>Address</mat-label>
        <textarea matInput formControlName="address" rows="2"></textarea>
        <mat-error>Address is <strong>required</strong></mat-error>
      </mat-form-field>
      <mat-form-field appearance="outline" class="col-md-4">
        <mat-label>City</mat-label>
        <input matInput formControlName="city">
        <mat-error>City is <strong>required</strong></mat-error>
      </mat-form-field>
      <mat-form-field appearance="outline" class="col-md-4">
        <mat-label>State</mat-label>
        <mat-select formControlName="state">
          <mat-option *ngFor="let s of stateslist" [value]="s.name">{{ s.name }}</mat-option>
        </mat-select>
        <mat-error>State is <strong>required</strong></mat-error>
      </mat-form-field>
      <mat-form-field appearance="outline" class="col-md-4">
        <mat-label>Zipcode</mat-label>
        <input matInput formControlName="zipcode" maxlength="6">
        <mat-error>Zipcode is <strong>required</strong></mat-error>
      </mat-form-field>
      <mat-form-field appearance="outline" class="col-md-4">
        <mat-label>Donation Type (group)</mat-label>
        <input matInput formControlName="groupkey">
        <mat-error>Donation type is <strong>required</strong></mat-error>
      </mat-form-field>
      <mat-form-field appearance="outline" class="col-md-8">
        <mat-label>Description</mat-label>
        <input matInput formControlName="description">
        <mat-error>Description is <strong>required</strong></mat-error>
      </mat-form-field>
    </form>
  </ng-container>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button mat-dialog-close [disabled]="isSaving">Cancel</button>
  <button mat-raised-button color="primary" (click)="submit()" [disabled]="isLoading || isSaving">
    Add to Donations
  </button>
</mat-dialog-actions>
